import mainTheme from './main';
import { colors } from '@material-ui/core';

const main = '#780006';
const dark = "#5d272c";
const light = "#af202e";

export default {
  ...mainTheme,
  primary: {
    dark: dark,
    main: main,
    light: light
  },
};

